import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromUi from '../reducers/ui.reducer';
export const getUiState = createFeatureSelector<fromUi.State>('ui');

export const getBottomSheetState = createSelector(
  getUiState,
  fromUi.getBottomSheetState,
);
export const getSidebarState = createSelector(
  getUiState,
  fromUi.getSidebarState,
);
export const getMapSettingsState = createSelector(
  getUiState,
  fromUi.getMapSettingsState,
);

export const getShowLegend = createSelector(getUiState, fromUi.getShowLegend);
export const getNavbarState = createSelector(getUiState, fromUi.getNavbarState);
